// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type VarianceTabQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  filter: Types.ProjectChangeEventGraphsFilter;
}>;


export type VarianceTabQuery = { __typename?: 'Query', projectChangeEventGraphs: { __typename?: 'ProjectChangeEventGraphsResult', graphs: Array<{ __typename?: 'ProjectChangeEventGraph', type: Types.ProjectChangeEventGraphType, data: Array<{ __typename?: 'ProjectChangeEventGraphData', name: string, totalCostInCents: number, timesUsed?: number | null | undefined }> }> }, project:
    | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
   };

export type VarianceTab_ChartDataFragment = { __typename?: 'ProjectChangeEventGraphData', name: string, totalCostInCents: number, timesUsed?: number | null | undefined };

export const VarianceTab_ChartDataFragmentDoc = gql`
    fragment VarianceTab_ChartData on ProjectChangeEventGraphData {
  name
  totalCostInCents
  timesUsed
}
    `;
export const VarianceTabDocument = gql`
    query VarianceTab($projectId: ID!, $filter: ProjectChangeEventGraphsFilter!) {
  projectChangeEventGraphs(projectId: $projectId, filter: $filter) {
    graphs {
      type
      data {
        ...VarianceTab_ChartData
      }
    }
  }
  project(id: $projectId) {
    ...Named
    childrenRecursive {
      ...Named
    }
  }
}
    ${VarianceTab_ChartDataFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useVarianceTabQuery__
 *
 * To run a query within a React component, call `useVarianceTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useVarianceTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVarianceTabQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVarianceTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VarianceTabQuery, VarianceTabQueryVariables> & ({ variables: VarianceTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VarianceTabQuery, VarianceTabQueryVariables>(VarianceTabDocument, options);
      }
export function useVarianceTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VarianceTabQuery, VarianceTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VarianceTabQuery, VarianceTabQueryVariables>(VarianceTabDocument, options);
        }
// @ts-ignore
export function useVarianceTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<VarianceTabQuery, VarianceTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VarianceTabQuery, VarianceTabQueryVariables>;
export function useVarianceTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VarianceTabQuery, VarianceTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VarianceTabQuery | undefined, VarianceTabQueryVariables>;
export function useVarianceTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VarianceTabQuery, VarianceTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VarianceTabQuery, VarianceTabQueryVariables>(VarianceTabDocument, options);
        }
export type VarianceTabQueryHookResult = ReturnType<typeof useVarianceTabQuery>;
export type VarianceTabLazyQueryHookResult = ReturnType<typeof useVarianceTabLazyQuery>;
export type VarianceTabSuspenseQueryHookResult = ReturnType<typeof useVarianceTabSuspenseQuery>;
export type VarianceTabQueryResult = ApolloReactCommon.QueryResult<VarianceTabQuery, VarianceTabQueryVariables>;